import {
  TInKindSummaryDB,
  TInKindQuarterDetailDB,
} from 'data/types/inKind.types';
import { TExportCsvDB, TExportCsvUI } from 'data/types/generic.types';
import { exportCsvConverter } from 'data/convertors/general.converters';
import { downloadFile } from 'redux/services/fileServices';
import { authSplitApi } from 'redux/helpers/slice.helpers';

const summaryUrl = 'elcs/in-kind/summary';
const quarterSummaryUrl = 'elcs/in-kind/quarter-summary';
const exportUrl = 'elcs/in-kind/export';
const yearsUrl = 'elcs/in-kind/years';

export const inKindApi = authSplitApi('inKind', [
  'inKindSummary',
  'inKindQuarterDetail',
]).injectEndpoints({
  endpoints: build => ({
    getInKindSummary: build.query<
      TInKindSummaryDB,
      { elcId: string; year: number }
    >({
      query: ({ elcId, year }) => ({
        url: summaryUrl,
        method: 'GET',
        params: { elcId, year },
      }),
      providesTags: ['inKindSummary'],
    }),

    getInKindQuarterDetail: build.query<
      TInKindQuarterDetailDB,
      { elcId: string; year: number; quarter: number }
    >({
      query: ({ elcId, year, quarter }) => ({
        url: quarterSummaryUrl,
        method: 'GET',
        params: { elcId, year, quarter },
      }),
      providesTags: ['inKindQuarterDetail'],
    }),

    exportInKindTransactions: build.query<
      TExportCsvUI,
      { elcId: string; year: number; quarter?: number }
    >({
      query: ({ elcId, year, quarter }) => ({
        url: exportUrl,
        method: 'GET',
        params: { elcId, year, ...(quarter != null && { quarter }) },
      }),
      transformResponse: (data: TExportCsvDB) => {
        const convertedData = exportCsvConverter('csv').fromDb(data);
        downloadFile(convertedData.content, convertedData.fileName);
        return convertedData;
      },
    }),

    getInKindYears: build.query<number[], { elcId: string }>({
      query: ({ elcId }) => ({
        url: yearsUrl,
        method: 'GET',
        params: { elcId },
      }),
      providesTags: ['inKindSummary'],
    }),
  }),
});

export const {
  useGetInKindSummaryQuery,
  useGetInKindQuarterDetailQuery,
  useLazyExportInKindTransactionsQuery,
  useGetInKindYearsQuery,
} = inKindApi;
